import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row justify-between px-4 md:px-10 my-5">
        <div>
          <p>All © copyright reserved by REEBUK Health</p>
        </div>
        <div className="flex gap-4">
          <Link className="text-[#496ECC]">Terms & Conditions</Link>
          <Link className="text-[#496ECC]">Privacy Policy</Link>
        </div>
      </div>
    </>
  );
};

export default Footer;
